import { render, staticRenderFns } from "./negativeDetail.vue?vue&type=template&id=56d65876&scoped=true"
import script from "./negativeDetail.vue?vue&type=script&lang=js"
export * from "./negativeDetail.vue?vue&type=script&lang=js"
import style0 from "./negativeDetail.vue?vue&type=style&index=0&id=56d65876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d65876",
  null
  
)

export default component.exports